var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSquare83AError = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 80 80",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M62.5 47a2.5 2.5 0 0 1-2.5-2.5v-11a2.5 2.5 0 0 1 2.5-2.5h10a2.5 2.5 0 0 1 2.5 2.5v11a2.5 2.5 0 0 1-2.5 2.5h-10Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#DB5C67",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M65 47h7.5a2.5 2.5 0 0 0 2.5-2.5v-11a2.5 2.5 0 0 0-2.5-2.5H65"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M62.5 69a2.5 2.5 0 0 1-2.5-2.5v-11a2.5 2.5 0 0 1 2.5-2.5h10a2.5 2.5 0 0 1 2.5 2.5v11a2.5 2.5 0 0 1-2.5 2.5h-10Z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  stroke: "#DB5C67",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M65 69h7.5a2.5 2.5 0 0 0 2.5-2.5v-11a2.5 2.5 0 0 0-2.5-2.5H65"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  stroke: "#DB5C67",
  strokeWidth: 2,
  d: "M29 59.5a1.5 1.5 0 0 0 1.5 1.5h19a1.5 1.5 0 0 0 1.5-1.5v-19a1.5 1.5 0 0 0-1.5-1.5h-19a1.5 1.5 0 0 0-1.5 1.5v19Z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M21.5 23.5A2.5 2.5 0 0 0 24 26h11.5a2.5 2.5 0 0 0 2.5-2.5v-10a2.5 2.5 0 0 0-2.5-2.5h-14v12.5ZM59.5 23.5A2.5 2.5 0 0 0 62 26h11.5a2.5 2.5 0 0 0 2.5-2.5v-10a2.5 2.5 0 0 0-2.5-2.5h-14v12.5ZM17.5 50.5A2.5 2.5 0 0 0 20 48V36.5a2.5 2.5 0 0 0-2.5-2.5h-10A2.5 2.5 0 0 0 5 36.5v14h12.5ZM4 23.5A2.5 2.5 0 0 0 6.5 26H18a2.5 2.5 0 0 0 2.5-2.5V11h-14A2.5 2.5 0 0 0 4 13.5v10ZM42 23.5a2.5 2.5 0 0 0 2.5 2.5H56a2.5 2.5 0 0 0 2.5-2.5V11h-14a2.5 2.5 0 0 0-2.5 2.5v10ZM17.5 68a2.5 2.5 0 0 0 2.5-2.5V54a2.5 2.5 0 0 0-2.5-2.5H5v14A2.5 2.5 0 0 0 7.5 68h10Z"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  stroke: "#DB5C67",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M4 21v-7.5A2.5 2.5 0 0 1 6.5 11h29a2.5 2.5 0 0 1 2.5 2.5V21M42 21v-7.5a2.5 2.5 0 0 1 2.5-2.5h29a2.5 2.5 0 0 1 2.5 2.5V21M15 68H7.5A2.5 2.5 0 0 1 5 65.5v-29A2.5 2.5 0 0 1 7.5 34H15"
})));
SvgSquare83AError.viewBox = '0 0 80 80';
const ForwardRef = /*#__PURE__*/forwardRef(SvgSquare83AError);
export default ForwardRef;